import { render, staticRenderFns } from "./TipoDeAvaliacao.vue?vue&type=template&id=4055ee12&"
import script from "./TipoDeAvaliacao.vue?vue&type=script&lang=js&"
export * from "./TipoDeAvaliacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports